import { inject } from '@angular/core';
import { Router, RedirectCommand, type CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthService } from '../services/auth.service';

const REDIRECT = {
  LINK_INVALID: 'link-invalid',
  ACCOUNT_LOCKED: 'profile-locked',
  LINK_EXPIRED: 'link-expired',
} as const;

export const setPasswordGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = route.paramMap.get('token') ?? '';

  const redirect = (reason: string): RedirectCommand =>
    new RedirectCommand(router.parseUrl(`/invalid-password/${reason}`));

  return authService.verifyToken(token).pipe(
    map(({ isLinkValid, isPasswordReset, lockoutAttempt }) => {
      if (isLinkValid && isPasswordReset) {
        return lockoutAttempt > 3 ? redirect(REDIRECT.ACCOUNT_LOCKED) : true;
      }

      return redirect(REDIRECT.LINK_INVALID);
    }),
    catchError(() => of(redirect(REDIRECT.LINK_EXPIRED))),
  );
};
